import {
    Text,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    AccordionIcon,
    Box,
} from '@chakra-ui/react';
export interface CTASectionProps {
    title: string;
    subtitle?: string;
    list: {
        question: string;
        anwser: JSX.Element;
    }[];
}

const FAQ: React.FC<CTASectionProps> = ({ title, subtitle, list }) => {
    return (
        <Box
            display={'flex'}
            flexDirection={{ base: 'column', md: 'row' }}
            alignItems={'center'}
            gap={'30px'}
        >
            <Box w={'calc(100%/12*4)'}>
                <Text
                    textAlign="center"
                    fontSize="34px"
                    as="b"
                    className="text-wrapper"
                    align={{ base: 'center', md: 'left' }}
                    mb={{ base: '35px', md: '0' }}
                    width={'100%'}
                >
                    {title}
                </Text>
            </Box>
            <Box w={'calc(100%/12*8)'}>
                <Accordion>
                    {list.map(item => {
                        return (
                            <AccordionItem>
                                <h2>
                                    <AccordionButton
                                        padding={'20px 10px'}
                                        borderBottom={'1px solid rgba(200, 200, 200, 1)'}
                                    >
                                        <Box as="span" flex="1" textAlign="left">
                                            {item.question}
                                        </Box>
                                        <AccordionIcon />
                                    </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4}>{item.anwser}</AccordionPanel>
                            </AccordionItem>
                        );
                    })}
                </Accordion>
            </Box>
        </Box>
    );
};

export default FAQ;
